export default function RoadProgramEntries() {
  return (
    <table id="filetable">
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2026_RP_Paving_Map_Phase_B.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2026 Road Paving Map
          </a>
        </td>
        <td>2/19/2026</td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2026-RP-CRC-JDM.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2026 Road Program -  Contractor Responsibility Certification for JDM
          </a>
        </td>
        <td>1/30/2026</td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2025-RP_Paving_Map_Phase_A_Updated_June5.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2025 Updated Road Paving Map
          </a>
        </td>
        <td>6/5/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2025_RP_Paving_Map_Phase_A.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2025 Road Paving Map
          </a>
        </td>
        <td>3/23/2025</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/info/2025_RP_ExhibitA_Phase_A_Road_List.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; 2025 Phase A Road List
          </a>
        </td>
        <td>3/23/2025</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
